import { isEqual, isNil } from 'lodash';
import { FileUpload } from '@shared/components/blocks/types';
import { EditableField, Field } from './Field';

export class AuditCheckboxField implements EditableField {
  readonly fieldType = 'AuditCheckboxField';
  readonly checked: boolean;
  readonly files: FileUpload[];
  readonly notes: string;

  constructor({ checked, files, notes }: { checked: boolean; files: FileUpload[]; notes: string }) {
    this.checked = checked;
    this.files = files;
    this.notes = notes;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return (
      field instanceof AuditCheckboxField &&
      this.checked === field.checked &&
      isEqual(this.files, field.files) &&
      this.notes === field.notes
    );
  }

  toFieldJson() {
    return { checked: this.checked, files: this.files, notes: this.notes };
  }

  // A required checkbox means the user must check it; unchecked = empty
  get isEmpty() {
    return !this.checked;
  }

  static fromFieldJson(json: any): AuditCheckboxField | null {
    if (isNil(json) || typeof json !== 'object') {
      return null;
    }
    return new AuditCheckboxField({
      checked: typeof json.checked === 'boolean' ? json.checked : false,
      files: Array.isArray(json.files) ? json.files : [],
      notes: typeof json.notes === 'string' ? json.notes : '',
    });
  }
}
